import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Camera, Video, Zap } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const Tarifs = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <SEO 
        title="Tarifs Vidéaste Mariage Alsace | Prix Film de Mariage Strasbourg - Yastudio"
        description="Tarifs vidéaste mariage en Alsace : 1499€ HT pour 6h de couverture + option drone 250€. Film de mariage professionnel à Strasbourg, Mulhouse, Colmar. Devis gratuit."
        keywords="tarifs vidéaste mariage Alsace, prix film de mariage Strasbourg, vidéaste mariage pas cher Alsace, tarif vidéo mariage Grand Est, prix reportage vidéo mariage, film mariage drone tarif"
      />
      {/* Hero Section */}
      <section className="py-32 px-4 bg-gradient-to-b from-zinc-950 to-black">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            Prix d'un <span className="text-light-pink">Vidéaste Mariage</span><br />en Alsace
          </h1>
          <p className="text-xl md:text-2xl text-gray-300">
            Des prestations haut de gamme avec du matériel professionnel
          </p>
        </div>
      </section>

      {/* Main Offer Section */}
      <section className="py-20 px-4 bg-black">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 border-2 border-light-pink rounded-2xl p-10 md:p-16 text-center shadow-2xl">
            <h2 className="text-4xl md:text-5xl font-bold mb-8">
              Prestation Mariage Complète
            </h2>
            
            <div className="mb-12">
              <div className="text-6xl md:text-8xl font-bold text-light-pink mb-4">
                1 499€
              </div>
              <p className="text-2xl text-gray-300">HT - 6 heures de couverture</p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-12 text-left">
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Couverture complète de 6 heures</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Caméras 4K professionnelles (FX3 & FX6)</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Stabilisation professionnelle</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Enregistrement audio professionnel</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Éclairage discret et efficace</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Post-production haut de gamme</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Étalonnage professionnel des couleurs</span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="w-6 h-6 text-light-pink flex-shrink-0 mt-1" />
                <span className="text-lg">Film de mariage complet livré</span>
              </div>
            </div>

            <div className="bg-black/50 rounded-xl p-8 mb-8">
              <h3 className="text-3xl font-bold mb-4 text-mid-blue">Option Drone</h3>
              <div className="text-5xl font-bold text-white mb-2">+ 250€</div>
              <p className="text-gray-300 text-lg">
                Prises de vue aériennes spectaculaires avec drone Mavic Pro 4
              </p>
            </div>

            <Link to="/contact">
              <Button size="lg" className="bg-light-pink text-black hover:bg-light-pink/90 text-xl px-12 py-7 rounded-full">
                Demander un Devis Personnalisé
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Equipment Section */}
      <section className="py-20 px-4 bg-zinc-950">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-6">
            Un Film de Mariage Haut de Gamme
          </h2>
          <p className="text-xl text-gray-300 text-center mb-16 max-w-4xl mx-auto">
            Grâce à du matériel professionnel dernière génération
          </p>

          {/* Equipment Photos Gallery */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_alsace-wedding-pro/artifacts/9uygfdki_pexels-cottonbro-studio-3296434.jpeg"
                alt="Caméra professionnelle Sony FX3"
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_alsace-wedding-pro/artifacts/y9q4wu2k_pexels-cottonbro-studio-3206167.jpeg"
                alt="Équipement vidéo professionnel"
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_alsace-wedding-pro/artifacts/fjvfkgil_pexels-josh-sorenson-10782398.jpeg"
                alt="Setup de post-production professionnel"
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-black p-8 rounded-lg border border-zinc-800">
              <div className="w-16 h-16 bg-mid-blue rounded-full flex items-center justify-center mb-6">
                <Video className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold mb-4">Caméras Sony FX3 & FX6</h3>
              <p className="text-gray-400 leading-relaxed">
                Caméras plein format stabilisées pour une image fluide et cinématographique. 
                La qualité 4K professionnelle pour un rendu exceptionnel.
              </p>
            </div>

            <div className="bg-black p-8 rounded-lg border border-zinc-800">
              <div className="w-16 h-16 bg-mid-purple rounded-full flex items-center justify-center mb-6">
                <Camera className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold mb-4">Drone Mavic Pro 4</h3>
              <p className="text-gray-400 leading-relaxed">
                Prises de vue aériennes spectaculaires pour sublimer votre lieu de réception 
                et créer des images mémorables.
              </p>
            </div>

            <div className="bg-black p-8 rounded-lg border border-zinc-800">
              <div className="w-16 h-16 bg-light-pink rounded-full flex items-center justify-center mb-6">
                <Zap className="w-8 h-8 text-black" />
              </div>
              <h3 className="text-2xl font-bold mb-4">Post-Production Pro</h3>
              <p className="text-gray-400 leading-relaxed">
                MacBook Pro dernière génération pour une retouche fluide et précise. 
                Étalonnage des couleurs et mixage audio professionnel.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Statement */}
      <section className="py-20 px-4 bg-black">
        <div className="max-w-4xl mx-auto">
          <div className="bg-zinc-900 p-10 md:p-16 rounded-2xl border border-zinc-800">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center">
              La Qualité a un Coût
            </h2>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
              Pour un jour aussi important que votre mariage, on ne peut pas se permettre de prendre 
              des risques. Tout est pensé pour garantir une image fluide, un son clair, et un rendu 
              digne des plus belles productions.
            </p>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
              La qualité repose sur des outils fiables, des heures de préparation, et un savoir-faire 
              affiné au fil des années. Mes tarifs tiennent compte de ce matériel professionnel, mais 
              aussi du temps passé en post-production pour créer un film soigné et émouvant.
            </p>
            <p className="text-lg md:text-xl text-white font-semibold leading-relaxed">
              Que vous célébriez votre union dans un château, un domaine viticole ou une salle de 
              prestige, je m'engage à valoriser chaque lieu et chaque émotion, pour vous offrir un 
              souvenir authentique, vivant et intemporel.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-zinc-950 to-black">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Intéressé par nos services ?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Discutons de votre projet et créons ensemble un devis personnalisé
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-black hover:bg-gray-200 text-lg px-12 py-6 rounded-full">
              Demander un Devis Gratuit
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;